import View from './view';
export const Html = View;
